function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEthFull(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "6.8704 5.1612 488.5377 488.5377",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "All",
    transform: "matrix(0.6677660942077637, 0, 0, 0.6677660942077637, -163.67706298828125, -72.09928894042969)",
    style: {}
  }, /*#__PURE__*/React.createElement("g", {
    id: "Developer-Center",
    transform: "translate(-1008.000000, -2285.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-28",
    transform: "translate(382.000000, 2270.799999)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-29",
    transform: "translate(0.000000, 0.200001)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-10",
    transform: "translate(0.000000, 14.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-13"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-46",
    transform: "translate(626.400000, 0.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-45"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    className: "st0",
    cx: 620.8,
    cy: 481.5,
    r: 365.8,
    style: {
      fill: "rgb(98, 126, 234)"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    className: "st1",
    points: "632.2,207.1 632.2,409.9 803.6,486.5 \t\t\t\t\t\t\t\t",
    style: {
      fill: "rgb(255, 255, 255)",
      fillOpacity: 0.602
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path_1_",
    className: "st2",
    points: "632.2,207.1 460.8,486.5 632.2,409.9 \t\t\t\t\t\t\t\t",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path_2_",
    className: "st1",
    points: "632.2,617.9 632.2,755.7 803.7,518.4 \t\t\t\t\t\t\t\t",
    style: {
      fill: "rgb(255, 255, 255)",
      fillOpacity: 0.602
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path_3_",
    className: "st2",
    points: "632.2,755.7 632.2,617.9 460.8,518.4 \t\t\t\t\t\t\t\t",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path_4_",
    className: "st3",
    points: "632.2,586 803.6,486.5 632.2,409.9 \t\t\t\t\t\t\t\t",
    style: {
      fill: "rgb(255, 255, 255)",
      fillOpacity: 0.2
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    id: "Path_5_",
    className: "st1",
    points: "460.8,486.5 632.2,586 632.2,409.9 \t\t\t\t\t\t\t",
    style: {
      fill: "rgb(255, 255, 255)",
      fillOpacity: 0.602
    }
  })))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEthFull);
export default __webpack_public_path__ + "static/media/eth-full.12b8afcf7ea15ef73ca2e6ef592428ad.svg";
export { ForwardRef as ReactComponent };